import { _, isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const gapsRoutes: RouteConfig = {
  path: '/gaps',
  name: 'gaps',
  component: () => lazyLoadView(import('@/contexts/gaps/GapRegistersListView.vue')),
  meta: {
    title: _('Gaps'),
    icon: 'exclamation-square',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'gap_register',
    feature_id: 'GAPS',
  },
  children: [
    {
      path: ':id',
      name: 'gap',
      component: () => lazyLoadView(import('@/contexts/gaps/GapRegisterView.vue')),
      meta: {
        title: null,
        icon: 'exclamation-square',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'gap',
      },
    },
  ],
}
